import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAudioSettingsStyle0 = gravityIconIndividualCss;

const GravityIconAudioSettings = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4e03379f58653e67fc03fbdc4c47482a631040f3', color: this.color, size: this.size }, h("svg", { key: '53d28490997ac46cb0c050428a1287e1788ce200', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'af7f648678a60a60ddcfe336acee2feabc2de44d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 18.65a7.65 7.65 0 1 0 0-15.3 7.65 7.65 0 0 0 0 15.3ZM11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), h("path", { key: 'df29a14c0026ecccee0fc54552bc2660d19fa0ae', d: "M5.5 9.5A.5.5 0 0 1 6 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-3Zm2.5-3a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-9Zm2.5 2A.5.5 0 0 1 11 8h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H11a.5.5 0 0 1-.5-.5v-5Zm2.5-1a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-7Zm2.5 2A.5.5 0 0 1 16 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H16a.5.5 0 0 1-.5-.5v-3Z", fill: "currentColor" }))));
    }
};
GravityIconAudioSettings.style = GravityIconAudioSettingsStyle0;

export { GravityIconAudioSettings as gravity_icon_audio_settings };

//# sourceMappingURL=gravity-icon-audio-settings.entry.js.map